// extracted by mini-css-extract-plugin
module.exports = {"errorInfo":"NotFound_errorInfo__3xvxb"};